export default __webpack_public_path__ + "img/190aaf249938b76ebb9a37840a4215b9.png";